import React from "react";
import { ArrowRight, ArrowUpRight, Globe, Megaphone, Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ITEM_ICONS = [Megaphone, Globe, Sparkles];

export default function MoreServices() {
  const { t } = useLang();
  const m = t.moreServices;
  return (
    <section
      id="more-services"
      className="section-y bg-white"
      data-testid="more-services-section"
    >
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <span className="overline">{m.overline}</span>
            <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
              {m.title}
            </h2>
            <p className="mt-6 text-base md:text-lg text-brand-graphite leading-relaxed text-pretty">
              {m.lead}
            </p>
            <p className="mt-4 text-base md:text-lg text-brand-graphite leading-relaxed text-pretty">
              {m.body}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={m.externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                data-testid="more-services-external"
              >
                {m.external}
                <ArrowUpRight className="h-4 w-4" />
              </a>
              <a
                href="/#contact"
                className="btn-ghost"
                data-testid="more-services-cta"
              >
                {m.cta}
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-3 md:gap-4">
              {m.items.map((it, i) => {
                const Icon = ITEM_ICONS[i] || Sparkles;
                return (
                  <li
                    key={i}
                    className="card-soft card-soft-hover p-6 md:p-7 h-full flex flex-col"
                    data-testid={`more-services-item-${i}`}
                  >
                    <span className="grid place-items-center h-10 w-10 rounded-2xl bg-brand-ink text-white">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-5 font-heading text-base md:text-lg font-medium text-brand-ink">
                      {it.title}
                    </h3>
                    <p className="mt-2 text-sm text-brand-graphite leading-relaxed">{it.body}</p>
                  </li>
                );
              })}
              <li className="rounded-2xl border border-brand-mist bg-brand-cloud p-6 md:p-7 flex flex-col justify-between min-h-[160px]">
                <div className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-stone">
                  Schwesterplattform
                </div>
                <a
                  href={m.externalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-2 text-base font-medium text-brand-ink hover:text-brand-graphite transition-colors group"
                  data-testid="more-services-card-link"
                >
                  femmesonlinebusiness.com
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </li>
            </ul>
            <p className="mt-5 text-xs text-brand-stone leading-relaxed max-w-2xl">
              {m.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
